import './Welcome.scss'
import { MODAL_AUTH } from '@components/App/Modal/constants'
import { openModal } from '@storeOld/reducers/ui'
import { push } from 'redux-first-history'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import request from '@/services/request'
import { store } from '@/store/store'

export default () => {
  if (window.screen && window.screen.width <= 1023) {
    const meta = document.createElement('meta')
    meta.name = 'viewport'
    meta.content = 'width=device-width, initial-scale=1'
    document.head.insertBefore(meta, document.head.firstElementChild)
  }

  const el = document.getElementById('welcome')
  const projectCountEl = el.querySelector('#project-count')
  const generateContainer = document.querySelector('#aiGenerate')
  const aiGenerateTextarea =
    generateContainer.querySelector('.generate-textarea')
  const aiGenerateButton = generateContainer.querySelector('.generate-button')
  const presetButtons = generateContainer.querySelectorAll('.presets-button')

  const animationIds = []

  window.addEventListener(
    'DOMContentLoaded',
    () => {
      aiGenerateTextarea.style.height = 'auto'
    },
    { once: true, capture: true }
  )

  const documentHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
  }

  const handleObserve = (entries, observer) => {
    if (window.screen && window.screen.width >= 1024) {
      return
    }

    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('_animate')
      } else {
        entry.target.classList.remove('_animate')
      }
    })
  }

  const observer = new IntersectionObserver(handleObserve, {
    root: el,
    threshold: 1,
  })

  const updateGenerateButtonState = () => {
    const presetsWrapper = generateContainer.querySelector('.generate-presets')

    if (aiGenerateTextarea.value.trim()) {
      aiGenerateButton.removeAttribute('disabled')
      presetsWrapper.classList.add('hide')
    } else {
      aiGenerateButton.setAttribute('disabled', true)
      presetsWrapper.classList.remove('hide')
    }
  }

  presetButtons.forEach((button) => {
    button.addEventListener('mouseenter', (evt) => {
      aiGenerateTextarea.setAttribute(
        'placeholder',
        evt.target.getAttribute('data-preset-text')
      )
    })

    button.addEventListener('mouseleave', (evt) => {
      aiGenerateTextarea.setAttribute(
        'placeholder',
        'Ask Octopus to create a sitemap'
      )
    })
  })

  setTimeout(updateGenerateButtonState, 100)

  const handleForm = () => {
    sendGtmEvent(
      GtmTriggerName.WELCOME_AI_GENERATE,
      'Click to generate ai project from welcome promo'
    )

    store.dispatch(
      push(
        `/ai-sitemap/new-project?generationTheme=${aiGenerateTextarea.value}`
      )
    )

    onClose()
  }

  el.style.display = 'flex'
  document.addEventListener('click', onDocumentClick)
  documentHeight()
  showProjectCounts()
  hideLogIn()
  animateMousePointer()
  handleAiGenerateTextarea()

  return null

  function onDocumentClick({ target }) {
    const classNameShow = '_show'
    const classNameBlur = '_blur'

    const welcomeRoot = el.querySelector('.welcome__root')
    const mobileHeader = el.querySelector('.mobile-header-wrap')
    const mobileDropdown = el.querySelector('.mobile-header__menu-dropdown')
    const allDropdowns = el.querySelectorAll('.mobile-header__inner-dropdown')

    if (target.classList.contains('welcome__overlay')) {
      onClose()
      return
    }

    if (!mobileHeader.contains(target)) {
      mobileDropdown.classList.remove(classNameShow)
      welcomeRoot.classList.remove(classNameBlur)
      allDropdowns.forEach((ad) => {
        ad.classList.remove(classNameShow)
      })
    }

    while (target && target.nodeType === 1 && !(target === el)) {
      const action = target.getAttribute('data-action')

      if (action === 'ai-generate') {
        handleForm()

        return
      }

      if (action === 'preset') {
        aiGenerateTextarea.value = target.getAttribute('data-preset-text')
        updateGenerateButtonState()

        return
      }

      if (action === 'navigate') {
        const hash = target.getAttribute('data-hash')

        if (hash) {
          setTimeout(() => {
            store.dispatch(openModal(MODAL_AUTH))
          }, 700)

          onClose()
        }

        return
      }

      if (action === 'redirect') {
        const hash = target.getAttribute('data-hash')

        if (hash) {
          store.dispatch(push(`/${hash}`))

          onClose()
        }

        return
      }

      if (action === 'close') {
        onClose()
        return
      }

      if (action === 'openDropdown') {
        const dropdown = target.nextElementSibling

        if (dropdown.classList.contains(classNameShow)) {
          dropdown.classList.remove(classNameShow)
        } else {
          allDropdowns.forEach((ad) => {
            ad.classList.remove(classNameShow)
          })

          dropdown.classList.add(classNameShow)
        }
      }

      if (action === 'import') {
        sendGtmEvent(
          GtmTriggerName.WELCOME_CRAWLER_GENERATE,
          'Click to crawl from welcome promo'
        )

        return
      }

      if (action === 'openMenu') {
        if (mobileDropdown.classList.contains(classNameShow)) {
          mobileDropdown.classList.remove(classNameShow)
          welcomeRoot.classList.remove(classNameBlur)
        } else {
          mobileDropdown.classList.add(classNameShow)
          welcomeRoot.classList.add(classNameBlur)
        }

        return
      }

      target = target.parentNode
    }
  }

  function onClose() {
    const mouseContainer = el.querySelector('.welcome__mouse-container')
    document.removeEventListener('click', onDocumentClick)
    el.classList.add('_revertAnimation')
    mouseContainer.classList.add('opacity')
    animationIds.forEach((id) => {
      cancelAnimationFrame(id)
    })

    setTimeout(() => {
      el.style.display = 'none'
      document.body.style.overflow = ''
      el.classList.remove('_revertAnimation')
      mouseContainer.classList.remove('opacity')
    }, 500)

    observer.disconnect()

    const viewport = document.querySelector(
      "[name='viewport'][content='width=device-width, initial-scale=1']"
    )

    if (viewport) {
      viewport.remove()
    }
  }

  function showProjectCounts() {
    request
      .get('projects/latest')
      .then((response) => {
        projectCountEl.innerHTML = response.count
      })
      .catch((e) => {
        // biome-ignore lint/suspicious/noConsole: intentional
        console.log(e)
      })
  }

  function hideLogIn() {
    const logInBtns = el.querySelectorAll('[data-id="logIn"]')
    const dashboardBtns = el.querySelectorAll('[data-id="dashboard"]')

    const token = localStorage.getItem('token')

    if (token) {
      logInBtns.forEach((logInBtn) => {
        logInBtn.classList.add('hide')
      })

      dashboardBtns.forEach((dashboardBtn) => {
        dashboardBtn.classList.remove('hide')
      })
    }
  }

  function animateMousePointer() {
    const users = Array.from(document.querySelectorAll('.welcome__mouse-user'))
    const padding = 20
    const userSize = 44

    users.forEach((user) => {
      let x = padding + Math.random() * (window.innerWidth - 2 * padding)
      let y = padding + Math.random() * (window.innerHeight - 2 * padding)
      let angle = Math.random() * 2 * Math.PI
      const speed = 0.75 + Math.random()

      function move() {
        angle += (Math.random() - 0.5) * 0.3

        x += Math.cos(angle) * speed
        y += Math.sin(angle) * speed

        const maxX = window.innerWidth - padding - userSize
        const maxY = window.innerHeight - padding - userSize
        const minX = padding
        const minY = padding

        if (x < minX || x > maxX) {
          angle = Math.PI - angle
          x = Math.max(minX, Math.min(x, maxX))
        }

        if (y < minY || y > maxY) {
          angle = -angle
          y = Math.max(minY, Math.min(y, maxY))
        }

        user.style.transform = `translate(${x}px, ${y}px)`
        const id = requestAnimationFrame(move)
        animationIds.push(id)
      }

      move()
    })
  }

  function handleAiGenerateTextarea() {
    const changeTextareaHeight = (evt) => {
      const { target } = evt

      target.style.height = 'inherit'
      const { scrollHeight } = target

      target.style.height = `${scrollHeight}px`
    }

    aiGenerateTextarea.addEventListener('input', (evt) => {
      updateGenerateButtonState()
      changeTextareaHeight(evt)
    })

    aiGenerateTextarea.addEventListener('keydown', (evt) => {
      if ((evt.ctrlKey || evt.metaKey) && evt.key === 'Enter') {
        evt.preventDefault()

        const value = evt.target.value.trim()
        if (!value) {
          return
        }

        handleForm()
      }
    })

    aiGenerateTextarea.addEventListener('focus', () => {
      generateContainer.classList.add('focused')
    })

    aiGenerateTextarea.addEventListener('blur', () => {
      generateContainer.classList.remove('focused')
    })
  }
}
